<template>
    <v-text-field class="centered-input"
        hide-details dense outlined readonly disabled
        :label="label"
        :ref="name"
        :placeholder="label"
        :value="newValue"
    ></v-text-field>
</template>
<script>
export default {
    name: 'DateTimeInput',
    props: ['label', 'format', 'name', 'value', 'blocked'],
    data: () => ({
    }),
    computed: {
        dateValue() {
            return this.getDateValue(this.value)
        },
        newValue() {
            return this.formatDate(this.dateValue)
        },
    },
    mounted() {
    },
    methods: {
        formatDate (datetime) {
            if (!datetime || datetime.search("-") < 0) return null
            const [date, time] = datetime.split(' ')
            const [year, month, day] = date.split('-')
            const [hours, minutes, seconds] = time.split(':')
            const d = new Date(year, month - 1, day, hours, minutes, seconds)
            return d.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", })
        },
        getDateValue(date) {
            if (!date || date.search("-") < 0) return null
            return date
        },
    },
}
</script>
<style scoped>
.centered-input >>> input {
    text-align: center
}
</style>